import { render, staticRenderFns } from "./ProbackToTrain.vue?vue&type=template&id=4115fdc2&scoped=true"
import script from "./ProbackToTrain.vue?vue&type=script&lang=js"
export * from "./ProbackToTrain.vue?vue&type=script&lang=js"
import style0 from "./ProbackToTrain.vue?vue&type=style&index=0&id=4115fdc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4115fdc2",
  null
  
)

export default component.exports